var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-abnormal',{attrs:{"imageUrl":_vm.imageUrl,"status":"500","tips":"抱歉，服务器出错了"}})
}
var staticRenderFns = []

export { render, staticRenderFns }